/* global document */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2';
import VueShave from 'vue-shave';
import VueScrollTo from 'vue-scrollto';
import VueBgSrc from 'vue-bg-src';

import { router } from './router';
import { TranslatedComponent } from './mixins/translated-component';
import { SiteData } from './mixins/site-data';
import template from './app.vhtml';
import { translations } from './translation.js';

import QdSearch from './components/search/search.js';

Vue.use(VueRouter);
Vue.use(VueClipboard);
Vue.use(VueI18n);
Vue.use(VueShave);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 800,
  easing: 'ease-in-out',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.use(VueBgSrc, {
  mediaQueries: {
    md: '(min-width: 415px)',
    lg: '(min-width: 736px)',
    xl: '(min-width: 1000px)',
  },
});

const i18n = new VueI18n({
  locale: 'da', // set locale
  messages: translations, // set locale messages
});

new Vue({
  i18n: i18n,
  el: '#app',
  mixins: [TranslatedComponent, SiteData],
  components: {
    QdSearch,
  },
  template: template,
  router: router,
  data: () => ({
    appLoaded: false,
    transition: 'slide',
  }),
  watch: {
    language() {
      i18n.locale = this.language;
    },
  },
  methods: {
    updateLangs(langs) {
      this.langs = langs;
    },
    updateTransition(transition) {
      this.transition = transition;
    },
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
      vm.appLoaded = true;
    }, 1000);
  },
});



// WEBPACK FOOTER //
// ./assets/_js/app.js